import {Component, Input, ViewChild} from '@angular/core';
import {CallService} from "../../shared/services/call/call.service";
import {HeaderComponent} from "../../layout/header/header.component";
import {Router} from "@angular/router";

@Component({
  selector: 'app-call-button',
  templateUrl: './call-button.component.html',
  styleUrl: './call-button.component.scss'
})
export class CallButtonComponent {

  @ViewChild('header') header: HeaderComponent;

  constructor(private readonly callService: CallService, public router: Router) {
  }

  @Input() phone: string;

  //Class Value; bootstap button class
  @Input() class?: string;


  /*  onCallbutton() {
      this.callService.callAction(-1, this.phone, 'make').subscribe((res: any) => {
        window.open('/?callType=OUTBOUND&queueNumber=&agentId=&callerDn=' + res.callerDn + '&phone=' + res.phone + '&callId=' + res.callId + '&ucid=' + res.ucid);
      });
    }*/


  onCallbutton() {
    const station = localStorage.getItem('station')!;
    const action = 'make';

    this.callService.callLocalApi(action, this.phone, -1, station).subscribe({
      next: (localResponse: any) => {
        this.callService.callAction(-1, this.phone, action, localResponse).subscribe({
          next: (res: any) => {
            if (res.callId) {
              window.open(
                `/?callType=OUTBOUND&queueNumber=&agentId=&callerDn=${res.callerDn}&phone=${res.phone}&callId=${res.callId}&ucid=${res.ucid}`
              );
            }
          },
          error: (err) => console.error('NestJS hata:', err),
        });
      },
      error: (err) => console.error('Lokal API hata:', err),
    });
  }


}
